import {Component, OnInit, Output, EventEmitter, Input, ViewChild} from '@angular/core';
import {Globals} from '../../../globals';
import * as moment from 'moment';
import {ImagingTopMenuEvent} from './models/imaging-top-menu.event';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {TDOxImage} from '../models/imaging-image.model';
import {ImagingCategoriesMenuComponent} from '../imaging-categories-menu/imaging-categories-menu.component';
import {TdoImagingImageContainerComponent} from '../tdo-imaging-image-container/tdo-imaging-image-container.component';
import {FolderMonitorName, TdoImagingService} from '../tdo-imaging.service';
import {DesktopAcquireCommandsModel} from '../models/desktop-acquire-commands.model';
import {DevicesService} from '../../../modules/configuration/devices/devices.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TdoDropdownModel} from '../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {Constants} from '../../../constants';
import {DialogService} from '../../../services/dialog.service';
import {SignalrService} from '../../../services/socket/signalr.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {PresentationFoldersConfigurationModel} from '../../../models/configuration/presentation-folders-configuration.model';
import {SaveLibLecDialogComponent} from '../../../dialog/save-lib-lec-dialog/save-lib-lec-dialog.component';
import {FolderMonitorParameters} from '../../../models/configuration/workstation-devices-configuration.model';
import { DEVICE_CATEGORY } from 'src/app/models/constants/device-category.model';

@Component({
  selector: 'app-imaging-top-menu',
  templateUrl: './imaging-top-menu.component.html',
  styleUrls: ['./imaging-top-menu.component.scss']
})
export class ImagingTopMenuComponent implements OnInit {
  @Output() topMenuEvent = new EventEmitter<ImagingTopMenuEvent>();
  @Input() openItems: TDOxImage[] = [];
  @Input() selectedContainer: TdoImagingImageContainerComponent;
  @Input() isShowBadge: boolean = false;

  @ViewChild('categoriesMenu') categoryMenu: ImagingCategoriesMenuComponent;

  topLabel: string;
  patientBirthday: moment.Moment;
  isShowPositioningMenu = false;
  menus: any;
  public folderMonitorNameList: FolderMonitorName[] = [];
  public folderMonitorName: FolderMonitorName;
  menu: any;
  globalsData: Globals;
  // isShowBadge: boolean = false;
  cameraToolTip: string = 'Start Folder Monitor';
  workstationDeviceList: any [];
  selectedDevice: DropDownListItems;
  storedDeviceId: string;
  listOfButtonItems: DropDownListItems[] = [];
  // listOfButtonItems: DropDownListItems[] = [
  //   { buttonItemID : '1' , buttonItemCaption: 'XDR' },
  //   { buttonItemID : '2' , buttonItemCaption: 'CareStream' },
  //   { buttonItemID : '3' , buttonItemCaption: 'Camera' },
  // ];
  selectedButtonItemCation = 'Test';
  selectedCBCTDevice: DropDownListItems;
  storedCBCTDeviceId: string;
  listOfCBCTButtonItems: DropDownListItems[] = [];
  selectedFolder: PresentationFoldersConfigurationModel;

  constructor(globals: Globals,
              private devsService: DevicesService,
              private localStorageService: LocalStorageService,
              private dialogService: DialogService,
              private socketService: SignalrService,
              private dialog: MatDialog,
              private drawService: TdoImagingService) {
    this.patientBirthday = globals.ThePatient?.BirthDate ? moment(globals.ThePatient.BirthDate) : null;
    if (this.patientBirthday) {
      this.topLabel = globals.currentPatientFullName + ' (' + moment().diff(this.patientBirthday, 'years') + ')';
    } else {
      this.topLabel = globals.currentPatientFullName;
    }
    this.globalsData = globals;
    // this.selectedButtonItemCation = this.listOfButtonItems[0].buttonItemCaption;
  }

  ngOnInit(): void {
    // Check if folder monitor is running on the computer. If it is show the badge
    // this.isFolderMonitorRunning();
    this.getDevicefromLocalStorage();
    // this.getWSName();

    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.getWSNameWithMacAddress(() => {
            const intervalSubscription2 = setInterval(_ => {
              if (this.drawService.wsNameWithMACAddress !== '') {
                clearInterval(intervalSubscription2);
                this.globalsData.WorkStationName = this.drawService.wsNameWithMACAddress;
                console.log('this.globals.WorkStationName ' + this.drawService.wsNameWithMACAddress);
                this.getWsDevicesList();
              }
            }, 100);
          });
        } /*else {
          clearInterval(intervalSubscription);
          this.globalsData.WorkStationName = 'WSTEST';
          console.log('Service Broker is not running using default workstaion name WSTEST');
          return;
        }*/
      }, 100);
    });

    // this.getWsDevicesList();
    this.socketService.messageUser.subscribe((sockRes) => {
      switch (sockRes.messageType) {
        case 'FOLDER_MONITOR_CHECK':
          this.isFolderMonitorRunning();
          break;
      }
    });
  }
  getDevicefromLocalStorage() {
    this.storedDeviceId = localStorage.getItem('IMAGE_ACQUIRE_DEVICE');
    if (!this.storedDeviceId) {
      // localStorage.setItem('IMAGE_ACQUIRE_TWAIN', JSON.stringify(this.selectedTwain));
      // this.storedDeviceId = localStorage.getItem('IMAGE_ACQUIRE_DEVICE');
    }
    else {
      if ( this.storedDeviceId === 'undefined') {
      }
      else {
        this.storedDeviceId = JSON.parse(this.storedDeviceId);
      }
    }

  }

  onTopMenuClick(value: string) {
    this.devsService.isServerConnected().subscribe(ddata => {
      const mod = new ImagingTopMenuEvent();
      if (value === 'drop-down-button') {
        console.log('mtm this.selectedDevice.buttonItemDeviceCat ', this.selectedDevice.buttonItemDeviceCat);
        if (this.selectedDevice.buttonItemDeviceCat === DEVICE_CATEGORY.Radiology) {
          value = 'xray';
        }
        else if (this.selectedDevice.buttonItemDeviceCat === DEVICE_CATEGORY.Portrait) {
          value = 'portrait';
        }
        else if (this.selectedDevice.buttonItemDeviceCat === DEVICE_CATEGORY.CBCTCarestream) {
          value = 'cbct';
        }
        else if (this.selectedDevice.buttonItemDeviceCat === DEVICE_CATEGORY.DSLRCamera) {
          value = 'camera';
          mod.deviceCategoryId = DEVICE_CATEGORY.DSLRCamera;
        }
        else if (this.selectedDevice.buttonItemDeviceCat === DEVICE_CATEGORY.Scanner) {
          value = 'scanner';
          mod.deviceCategoryId = DEVICE_CATEGORY.Scanner;
        }
      }

      switch (value) {
        case 'print':
          // console.log('mtm test folder monitor list');
          // this.onFolderMonitorMenuGetNames();
          break;
        case 'portrait':
          mod.folderMonitorName = this.selectedDevice.buttonItemFolderMonitorName;
          if (this.isShowBadge) {
            value = ImagingTopMenuEvent.STOP_CAMERA_PORTRAIT;
            this.cameraToolTip = 'Start Folder Monitor';
          }
          else {
            value = ImagingTopMenuEvent.START_CAMERA_PORTRAIT;
            this.cameraToolTip = 'Stop Folder Monitor';
          }
          break;
        case 'camera':
          mod.folderMonitorName = this.selectedDevice.buttonItemFolderMonitorName;
          if (this.isShowBadge) {
            value = ImagingTopMenuEvent.STOP_CAMERA;
            this.cameraToolTip = 'Start Folder Monitor';
          }
          else {
            value = ImagingTopMenuEvent.START_CAMERA;
            this.cameraToolTip = 'Stop Folder Monitor';
          }
          // this.isShowBadge = !this.isShowBadge;
          break;
        case 'xray':
          if (this.selectedDevice.buttonItemID === Constants.emptyGuid) {
            this.dialogService.openConfirmDialog('Please go to \'Settings -> Practice Information -> Devices\' to configure a device.',
              false, false, 'No Device Configured').subscribe((result) => {
              if (result === true) {
              }
            });

            return;
          }
          else {
            localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(this.selectedDevice.buttonItemID));
          }
          break;
        case 'cbct':
          localStorage.setItem('IMAGE_ACQUIRE_CBCT_DEVICE', JSON.stringify(this.selectedDevice.buttonItemID));
          break;
        case 'scanner':
          localStorage.setItem('IMAGE_ACQUIRE_CBCT_DEVICE', JSON.stringify(this.selectedDevice.buttonItemID));
          break;
        /*
              case 'save-lib-lec':
                this.openFolderSelector();
                break;
        */
      }
      mod.type = value;
      if (value === 'save-lib-lec') {
        this.openFolderSelector(mod);
      }
      else {
        this.topMenuEvent.emit(mod);
      }
    }, err => {
      console.log(err);
      this.dialogService.openConfirmDialog('Your session have timed out. Please Refresh (Ctrl+F5) or close Studio and log back in to continue.',
        false, false, 'Session Timed Out').subscribe((result) => {
        if (result === true) {
        }
      });
    });
  }

  openFolderSelector(mod: ImagingTopMenuEvent) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';

    //config.height = '600px';
    //config.width = '600px';

    config.data = {
      FromTable: 'LibraryLecture',
      PickList: 'true',
    };
    this.dialog.open(SaveLibLecDialogComponent, config).afterClosed().subscribe((result) => {
      if (result) {
        mod.folderIds = result;
        this.topMenuEvent.emit(mod);
      }
    });
    /*    const model = new ProcedureSelectionDialogModel();
        model.datasource = this.procedures;
        this.dialogService.openProcedureDialog(model).subscribe((res) => {
          if (res) {
            this.selectedLocation.FormsRepoCaseProcedureId = res.id;
          }
        });*/
  }

  onFolderMonitorMenuGetNames() {
    this.callServiceBroker('get_folder_monitor_names', '', () => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.folderMonitorNameList) {
          clearInterval(intervalSubscription);
          this.folderMonitorNameList = this.drawService.folderMonitorNameList;
        }
      },  100);
    });

  }
  isFolderMonitorRunning() {
    this.callServiceBroker('is-folder-monitor-running', '', () => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.folderMonitorRunning !== '') {
          clearInterval(intervalSubscription);
          if (this.drawService.folderMonitorRunning.toLowerCase() === 'true') {
            this.isShowBadge = true;
          }
          else {
            this.isShowBadge = false;
          }
        }
      },  100);
    });

  }
  stopFolderMonitor() {
    this.callServiceBroker('stop-folder-monitor', '', () => {
      const intervalSubscription = setInterval(_ => {
        if (true) {
          clearInterval(intervalSubscription);
          this.isShowBadge = false;
        }
      },  100);
    });
  }

  callServiceBroker(commandType: string, folderMonitorName: string, callback) {
    const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
    desktopAcquireCommandArgs.PatientName = this.globalsData.currentPatientFullName;
    desktopAcquireCommandArgs.LocId = this.globalsData.LOCID;
    /*desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
    desktopAcquireCommandArgs.PatientId = this.currentPatientID;
    desktopAcquireCommandArgs.PatientCaseId = this.currentPatientCaseID;
    desktopAcquireCommandArgs.ToothList = this.toothDetail;*/
    this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
    setTimeout(() => {
      callback();
    }, 200);
  }
  onFolderMonitorMenuSelect(value: string, name: string) {
    const mod = new ImagingTopMenuEvent();
    mod.type = value;
    // mod.folderMonitorName = name;
    this.topMenuEvent.emit(mod);
  }


  fileSelectednew(event: Event) {
    this.devsService.isServerConnected().subscribe(ddata => {
      const element = event.currentTarget as HTMLInputElement;
      const fileList: FileList | null = element.files;
      if (fileList) {
        const intervalSubscription = setInterval(_ => {
          if (fileList.length > 0) {
            clearInterval(intervalSubscription);
            const mod = new ImagingTopMenuEvent();
            mod.type = 'open-file';
            mod.selectedFiles = Array.from(fileList);
            this.topMenuEvent.emit(mod);
          }
        }, 100);
      }
    }, err => {
        console.log(err);
        this.dialogService.openConfirmDialog('Your session have timed out. Please Refresh (Ctrl+F5) or close Studio and log back in to continue.',
          false, false, 'Session Timed Out').subscribe((result) => {
          if (result === true) {
          }
        });
      });
  }

  fileSelected(event: Event) {
      const element = event.currentTarget as HTMLInputElement;
      const fileList: FileList | null = element.files;
      if (fileList) {
        const intervalSubscription = setInterval(_ => {
          if (fileList.length > 0) {
            clearInterval(intervalSubscription);
            const mod = new ImagingTopMenuEvent();
            mod.type = 'open-file';
            mod.selectedFiles = Array.from(fileList);
            this.topMenuEvent.emit(mod);
          }
        }, 100);
      }
  }


  onCategoriesSelected(event: EnumValidValueItemModel[]) {
    const mod = new ImagingTopMenuEvent();
    mod.type = ImagingTopMenuEvent.CATEGORIES;
    mod.categories = event;
    this.topMenuEvent.emit(mod);
  }

  openCategoriesMenu() {
    this.categoryMenu.isShowMenu = !this.categoryMenu.isShowMenu;

    if (this.categoryMenu.isShowMenu) {
      // Select items
      if (this.selectedContainer) {

      }
    }
  }
  getFolderMonitorNameFromJSON(paramJson: string) {
    const folderMonitorParam = JSON.parse(paramJson);
    return folderMonitorParam.MonitorName;
  }

  getWSName() {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.getWSNameWithMacAddress(() => {
            const intervalSubscription2 = setInterval(_ => {
              if (this.drawService.wsNameWithMACAddress !== '') {
                clearInterval(intervalSubscription2);
                this.globalsData.WorkStationName = this.drawService.wsNameWithMACAddress;
                console.log('this.globals.WorkStationName ' + this.drawService.wsNameWithMACAddress);
                this.getWsDevicesList();
              }
            }, 100);
          });
        } /*else {
          clearInterval(intervalSubscription);
          this.globalsData.WorkStationName = 'WSTEST';
          console.log('Service Broker is not running using default workstaion name WSTEST');
          return;
        }*/
      }, 100);
    });
  }


  getWsDevicesList() {
    // this.workstationDeviceList = [];
    // const WorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    // const WorkStationID = '0109553C-9946-EC11-BAA6-34CFF6FC526F';
    
    const enumDeviceCBCTCarestream = '00000263-1000-0000-0000-000000000005';
    const wsName = this.globalsData.WorkStationName.split('=', 2);
    this.devsService.getWSId(this.globalsData.LOCID, wsName[0]).subscribe(wdata => {
      const WorkStationID = wdata.WorkStationId;
      console.log('mtm WorkStationId ', WorkStationID);
      this.devsService.getAttachedDevices(WorkStationID.toString()).subscribe(ddata => {
        if (ddata.length > 0) {
          // const radiologyDevices = ddata.find(p => p.enumDeviceCategoryID === enumDeviceRadiology);
          for (const d of ddata) {
            // if (d.enumDeviceCategoryID === enumDeviceRadiology || d.enumDeviceCategoryID === enumDeviceDocumentScanner) {
            if (d.isConnected && d.isActive) {
              const item = new DropDownListItems();
              item.buttonItemCaption = d.Name;
              item.buttonItemID = d.WorkStationDeviceID;
              item.buttonItemDeviceCat = d.enumDeviceCategoryID;
              if (d.isStartFolderMonitor === true && d.ParametersJSON !== null) {
                item.buttonItemFolderMonitorName = this.getFolderMonitorNameFromJSON(d.ParametersJSON);
              }
              else {
                item.buttonItemFolderMonitorName = '';
              }
              this.listOfButtonItems.push(item);
            }
          }
          if (this.storedDeviceId !== null && this.storedDeviceId !== undefined && this.storedDeviceId !== '00000000-0000-0000-0000-000000000000') {
            if (this.listOfButtonItems.length > 0) {
              // check if the stored device id has not been removed
              const buttonItem = this.listOfButtonItems.find(p => p.buttonItemID === this.storedDeviceId);
              if (buttonItem === undefined) {
                if (this.listOfButtonItems.length > 0) {
                  // default to the first item
                  this.selectedDevice = this.listOfButtonItems[0];
                  localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(this.listOfButtonItems[0].buttonItemID));
                  this.storedDeviceId = this.listOfButtonItems[0].buttonItemID;
                }

                localStorage.setItem('is-Start-Folder-Monitor', JSON.stringify('false'));
                localStorage.setItem('tags-imaging', JSON.stringify(null));
              }
              else {
                this.selectedDevice = this.listOfButtonItems.find(p => p.buttonItemID === this.storedDeviceId);
              }
            }
          } else {
            if (this.listOfButtonItems.length > 0) {
              this.selectedDevice = this.listOfButtonItems[0];
              this.storedDeviceId = this.listOfButtonItems[0].buttonItemID;
              localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(this.listOfButtonItems[0].buttonItemID));
            }
          }
          if (this.storedCBCTDeviceId !== null && this.storedCBCTDeviceId !== undefined) {
            if (this.listOfCBCTButtonItems.length > 0) {
              this.selectedCBCTDevice = this.listOfCBCTButtonItems.find(p => p.buttonItemID === this.storedCBCTDeviceId);
            }
          } else {
            if (this.listOfCBCTButtonItems.length > 0) {
              this.selectedCBCTDevice = this.listOfCBCTButtonItems[0];
            }
          }
        }
        else {
          console.log('No device configured');
          const item = new DropDownListItems();
          item.buttonItemCaption = 'No device';
          item.buttonItemID = Constants.emptyGuid;
          this.listOfButtonItems.push(item);
          this.selectedDevice = this.listOfButtonItems[0];
        }
        // this.workstationDeviceList = ddata;
      }, err => {
        console.log(err);
        // return false;
      });




    }, err => {
      console.log(err);
      // return false;
    });



  }

  cascadeClicked() {
    const mod = new ImagingTopMenuEvent();
    mod.type = ImagingTopMenuEvent.CASCADE;
    this.topMenuEvent.emit(mod);
  }

  tileClicked(maxAcross: number) {
    const mod = new ImagingTopMenuEvent();
    mod.type = ImagingTopMenuEvent.TILE;
    mod.tileMax = maxAcross;
    this.topMenuEvent.emit(mod);
  }

  onDeviceSelected(event: TdoDropdownModel) {
    // save selected value
    localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(event.value));
  }
  doItemClick(e: DropDownListItems): void {
    localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(e.buttonItemID));
    if (this.isShowBadge) {
      const mod = new ImagingTopMenuEvent();
      mod.type = ImagingTopMenuEvent.STOP_CAMERA;
      mod.folderMonitorName = 'all';
      this.topMenuEvent.emit(mod);
    }

    this.selectedButtonItemCation = e.buttonItemCaption;
    this.selectedDevice = e;
  }
  doItemClickCBCT(e: DropDownListItems): void {
    localStorage.setItem('IMAGE_ACQUIRE_CBCT_DEVICE', JSON.stringify(e.buttonItemID));
    this.selectedButtonItemCation = e.buttonItemCaption;
    this.selectedCBCTDevice = e;
  }

  doButtonClick(e: DropDownListItems): void {
    console.log('Button was Clicked: ' + e.buttonItemCaption);
  }


}

export class DropDownListItems  {
  buttonItemID: string = '';
  buttonItemCaption: string = '';
  buttonItemDeviceCat: string = '';
  buttonItemFolderMonitorName: string = '';
}
